import { ELSButton, ELSFlex, ELSFlexItem } from 'components/common/els';

export interface SidebarActionsProps {
  enableSaveButton?: boolean;
  saveButtonText?: string;
  onSaveClick?: Function;
}

// Save is the drawer's only action: it is dismissed through the sidebar's own header close button
// or the Escape key, so it carries no secondary button.
const SidebarActions = ({ enableSaveButton, saveButtonText, onSaveClick }: SidebarActionsProps) => (
  <ELSFlex className="sng-form-buttons" left wrap>
    <ELSFlexItem>
      <ELSButton type="primary" text={saveButtonText} isDisabled={!enableSaveButton} onClick={onSaveClick} />
    </ELSFlexItem>
  </ELSFlex>
);

export default SidebarActions;
